import { render, staticRenderFns } from "./CreateAccessControl.vue?vue&type=template&id=994b444a&"
import script from "./CreateAccessControl.vue?vue&type=script&lang=js&"
export * from "./CreateAccessControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports